export class JobMetricsReportFailedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudAccountArguments",
            "baseName": "cloudAccountArguments",
            "type": "CloudAccountNotificationArguments",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobMetricsReportFailedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
